export default __webpack_public_path__ + "static/media/Undercurrent_20BTN.48973870.woff2";